import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import { Nav as SecondaryNav } from 'cccisd-laravel-appdefs';
var AppDefs = window.cccisd.appDefs;
import Footer from 'js/components/CCUFooter';
export default class FluidLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
    };

    render() {
        return (
            <div>
                <SecondaryNav
                    className="container-fluid"
                    navs={AppDefs.navs}
                    routes={AppDefs.routes}
                />
                <div className="container-fluid">{this.props.children}</div>
                <Footer />
            </div>
        );
    }
}
